'use client';

import { RefObject, useLayoutEffect, useState } from 'react';

// This hook return function focuses first error field within formRef.
// The return function should be called after validation errors are added.
// It won't do anything if there are no errors.

const useFocusFirstErrorComponent = (
  formRef: RefObject<HTMLFormElement | HTMLDivElement>,
): (() => void) => {
  const [counter, setCounter] = useState(0);

  useLayoutEffect(() => {
    const firstErrorComponentWithinForm: HTMLInputElement | null | undefined =
      formRef.current?.querySelector('[aria-invalid="true"]');

    if (firstErrorComponentWithinForm) {
      firstErrorComponentWithinForm.focus();
    }
  }, [counter, formRef]);

  return () => {
    setCounter((counter) => counter + 1);
  };
};

export default useFocusFirstErrorComponent;
